class BlogPosts {
    constructor(section) {
        this.section = section;
        this.grid = this.section.querySelector('.js-blog-posts-grid');
        this.moreButton = this.section.querySelector('.js-blog-posts-more');
        this.filters = Array.from(this.section.querySelectorAll('.blog-posts__filter'));

        this.ajaxUrl = this.section.dataset.ajaxUrl;
        this.nonce = this.section.dataset.nonce;
        this.postsPerPage = parseInt(this.section.dataset.postsPerPage, 10) || 9;
        this.currentPage = parseInt(this.section.dataset.currentPage, 10) || 1;
        this.maxPages = parseInt(this.section.dataset.maxPages, 10) || 1;
        this.currentCategory = this.section.dataset.currentCategory || '';
        this.isLoading = false;

        if (!this.grid || !this.ajaxUrl || !this.nonce) {
            return;
        }

        this.init();
    }

    init() {
        this.bindFilters();
        this.bindLoadMore();
        this.updateMoreButtonState();
    }

    bindFilters() {
        if (!this.filters.length) {
            return;
        }

        this.filters.forEach((filter) => {
            filter.addEventListener('click', () => {
                const category = filter.dataset.category ?? '';

                if (category === this.currentCategory || this.isLoading) {
                    return;
                }

                this.filters.forEach((item) => item.classList.remove('is-active'));
                filter.classList.add('is-active');

                this.currentCategory = category;
                this.currentPage = 1;

                this.fetchPosts(false);
            });
        });
    }

    bindLoadMore() {
        if (!this.moreButton) {
            return;
        }

        this.moreButton.addEventListener('click', () => {
            if (this.isLoading || this.currentPage >= this.maxPages) {
                return;
            }

            this.currentPage += 1;
            this.fetchPosts(true);
        });
    }

    async fetchPosts(append = false) {
        this.isLoading = true;
        this.section.classList.add('is-loading');

        const formData = new FormData();
        formData.append('action', 'theme_load_blog_posts');
        formData.append('nonce', this.nonce);
        formData.append('page', this.currentPage);
        formData.append('posts_per_page', this.postsPerPage);
        formData.append('category', this.currentCategory);

        try {
            const response = await fetch(this.ajaxUrl, {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();

            if (!result.success) {
                throw new Error('Request failed');
            }

            this.maxPages = parseInt(result.data.max_pages, 10) || 1;
            this.section.dataset.maxPages = this.maxPages;

            if (append) {
                this.grid.insertAdjacentHTML('beforeend', result.data.html);
            } else {
                this.grid.innerHTML = result.data.html;
            }

            this.updateMoreButtonState();
        } catch (error) {
            console.error('Blog posts AJAX error:', error);
        } finally {
            this.isLoading = false;
            this.section.classList.remove('is-loading');
        }
    }

    updateMoreButtonState() {
        if (!this.moreButton) {
            return;
        }

        this.moreButton.hidden = this.maxPages <= 1 || this.currentPage >= this.maxPages;
    }

    static initAll() {
        const sections = document.querySelectorAll('.js-blog-posts');

        if (!sections.length) {
            return;
        }

        sections.forEach((section) => {
            if (section.blogPostsInstance) {
                return;
            }

            section.blogPostsInstance = new BlogPosts(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    BlogPosts.initAll();
});